import { useCallback } from "react";
import { listTeamTrainingMembers, type MemberRef } from "@/api";
import { useAsyncList, type AsyncListState } from "./useAsyncList";

// Training·Evaluation 팀 필터가 함께 쓰는 멤버 후보 소스. 그룹이 아직 없거나 Me 스코프면 요청하지
// 않고 빈 목록을 반환한다.
export function useTeamMembers(
  enabled: boolean,
  groupUuid: string | null,
): AsyncListState<MemberRef> {
  const fetcher = useCallback(() => {
    if (!enabled || groupUuid === null) {
      return Promise.resolve<readonly MemberRef[]>([]);
    }
    return listTeamTrainingMembers(groupUuid);
  }, [enabled, groupUuid]);

  return useAsyncList(fetcher);
}
